import { InterfaceType } from 'frontend/_setup/setupContainer/constants/InterfaceType'
import { inject, injectable } from 'inversify'
import { type Ref } from 'vue'
import { type RouteLocationNormalizedLoaded } from 'vue-router'

import { IDataModelTypeStrategy } from '../../../types/IDataModelTypeStrategy'

@injectable()
export class OperationalServiceLevelDataModelTypeStrategy implements IDataModelTypeStrategy {
  public readonly baseUrl: string
  public readonly canEditColumns = false

  constructor(
    @inject(InterfaceType.constants.CurrentRoute)
    private currentRoute: Ref<RouteLocationNormalizedLoaded>,
  ) {
    this.baseUrl = currentRoute.value.params.eventSlug
      ? `/events/${currentRoute.value.params.eventSlug}/operational_service_levels`
      : '/operational_service_levels'
  }
}
